import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { TRACK_OFFICE_INFO_BUTTON_CLICK } from '@services/stats';
import getOfficeSlug from '@helpers/getOfficeSlug';

import st from './Name.module.css';

const handlerClick = () => {
  TRACK_OFFICE_INFO_BUTTON_CLICK('header');
  setTimeout(() => {
    document.querySelector('body').scrollIntoView();
  }, 100);
};

type NameProps = {
  isDetailed: boolean;
  isClosed: boolean;
  office: {
    name: string;
    id: number;
  };
};

const Name: FC<NameProps> = ({ isDetailed, office, isClosed }) =>
  isDetailed ? (
    <h1 className={isClosed ? st.nameDetailedClosed : st.name}>
      {office.name}
    </h1>
  ) : (
    <Link
      data-testid="nameLink"
      className={!isClosed ? st.clickableName : st.nameClosed}
      to={`/services/centry-gosudarstvennyh-uslug/${getOfficeSlug(office)}`}
      onClick={handlerClick}
    >
      {office.name}
    </Link>
  );

export default Name;
